var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-mask",on:{"touchmove":function($event){$event.stopPropagation();$event.preventDefault();}}})
}
var staticRenderFns = []

export { render, staticRenderFns }